import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export function InvoiceRejectModal({ open, onOpenChange, onSubmit, isSubmitting }) {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const [wasOpen, setWasOpen] = useState(open);

  // Reset while opening, not in an effect: an effect would render the previous
  // reason once before clearing it.
  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) {
      setReason("");
      setComment("");
    }
  }

  const submit = (event) => {
    event.preventDefault();
    onSubmit({ reason, comment });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false} className="max-w-md">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>Reject review</DialogTitle>
            <DialogDescription>
              Provide a reason and notes. The invoice will return to the supplier queue.
            </DialogDescription>
          </DialogHeader>

          <DialogBody className="space-y-4">
            <div className="invoice-detail-field">
              <label htmlFor="reject-reason" className="invoice-detail-label">
                Reason
              </label>
              <Input
                id="reject-reason"
                required
                value={reason}
                onChange={(event) => setReason(event.target.value)}
                className="h-10 rounded-[0.8rem] border-line bg-background shadow-none"
              />
            </div>
            <div className="invoice-detail-field">
              <label htmlFor="reject-comment" className="invoice-detail-label">
                Comments
              </label>
              <textarea
                id="reject-comment"
                required
                rows={4}
                value={comment}
                onChange={(event) => setComment(event.target.value)}
                className="invoice-detail-textarea"
              />
            </div>
          </DialogBody>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              className="h-9 rounded-[0.8rem] border-line shadow-none sm:min-w-24"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="destructive"
              className="h-9 rounded-[0.8rem] sm:min-w-24"
              disabled={isSubmitting}
            >
              Reject invoice
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
